ChooseSlotsController.$inject = ["$http", "API_URL", "$rootScope", "$location", "$timeout"];
angular.module('calendarApp').controller('ChooseSlotsController', ChooseSlotsController);

function ChooseSlotsController($http, API_URL, $rootScope, $location, $timeout) {
  var choose = this;

  function init() {
    if (!$rootScope.chosenShift) {
      $location.path('/');
      return;
    }

    choose.shift = null;
    choose.selectedSlots = []; // If there are previously reserved appointments, delete them as it will cause a mess
    // if the user chooses a new service

    var appointments = localStorage.getItem('reserved-appointments');

    if (appointments) {
      localStorage.removeItem('reserved-appointments');
    }

    $rootScope.chosenShift.timeslots.forEach(function (timeslot) {
      if (appointments && appointments.length) {
        for (var i = 0; i < appointments.length; i++) {
          if (appointments[i].serviceid === timeslot.serviceid && appointments[i].resourceid === timeslot.resourceid && appointments[i].start === timeslot.start && appointments[i].end === timeslot.end) {
            timeslot.selected = timeslot.selected ? timeslot.selected + 1 : 1;
          } else {
            timeslot.selected = 0;
          }
        }
      } else {
        timeslot.selected = 0;
      }
    });
    choose.timeSettings = smooth.timeSettings;
    moment.tz.setDefault(choose.timeSettings.timezone);
    choose.shift = $rootScope.chosenShift;
    choose.shift.date = moment.unix(choose.shift.start).format('YYYY-MM-DD');
    choose.waitlist = choose.shift && choose.shift.canwaitlist;

    if (choose.shift.isworkshop && choose.shift.dates.length > 1) {
      choose.shiftInfo = "You are booking a workshop with "; // ????
    } // If there is only one timeslot in the shift then don't show the chooser.
    // What happens next depends on whether the 'show future slots' config is set

  }

  init();

  choose.goBack = function () {
    $location.path('/');
  };

  choose.continue = function () {
    // At this point we're beginning to build an array of appointments to book
    var newAppointments = [];
    choose.selectedSlots.forEach(function (slotIndex) {
      var appointment = {
        serviceid: choose.shift.timeslots[slotIndex].serviceid,
        start: choose.shift.timeslots[slotIndex].start,
        end: choose.shift.timeslots[slotIndex].end,
        date: choose.shift.date,
        shiftid: choose.shift._id
      };

      if (choose.shift.timeslots[slotIndex].hasresource) {
        appointment.hasresource = true;
        appointment.resourceid = choose.shift.timeslots[slotIndex].resourceid;
      } else {
        appointment.hasresource = false;
      }

      if (choose.shift.isworkshop) {
        appointment.workshopshiftid = choose.shift._id;
      }

      newAppointments.push(appointment);
    });
    $rootScope.throbber.show(); // Now save the appointments tentatively to the server (and to local storage?)

    $http.post(API_URL + '/api/v1/calendar/appointment/reserve', {
      appointments: newAppointments,
      orgid: smooth.orgid
    }).then(function (reply) {
      $rootScope.throbber.hide();
      var response = reply.data;

      if (response.orgidmismatch) {
        $rootScope.throbber.showError('Sorry but you are logged into the calendar for the wrong organisation. You will need to login again.');
        $timeout(function () {
          $rootScope.customerInfo = null;
          localStorage.removeItem('calendar-jwt-token');
          $location.path('#/login');
          $rootScope.safeApply();
        }, 3000);
        return;
      } // Show any overbooked timeslots


      if (response.overbooked) {
        $rootScope.overBooked = [];
        $rootScope.overBooked = response.overbookedappointments; // If some appointments were made and some were not, let the user choose which ones they
        // want to keep

        if (response.appointments.length) {
          // Store timeslots
          var _reservedAppointments = response.appointments;
          localStorage.setItem('reserved-appointments', JSON.stringify(_reservedAppointments));
          $location.path('/overbooked/chooseslots');
        } else {
          // None of the chosen appointments were allowed.
          choose.noneAllowed = true;
          $timeout(function () {
            choose.noneAllowed = false;
          }, 3000);
        }

        return;
      } // Store tentative appointments in local storage


      if (!response.appointments || !response.appointments.length) {
        return;
      } // Store appointments in all cases


      var reservedAppointments = response.appointments;
      localStorage.setItem('reserved-appointments', JSON.stringify(reservedAppointments)); // If this is a workshop with 'bookall' or 'bookremaining' set, skip the futureslots page

      var shift = reservedAppointments[0].shiftid;
      if (shift.isworkshop && (shift.bookall || shift.bookremaining)) return $location.path('/review'); // If settings allow, go to future slots

      if (smooth.calendarSettings.bookfuturedays) {
        $location.path('/futureslots');
      } else {
        $location.path('/review');
      }
    }).catch(function (err) {
      $rootScope.throbber.showError("Sorry but an error occurred with this request: ".concat(err.message, ". Please contact support@smoothbook.co if this error persists"));
    });
  };

  choose.addTimeslot = function ($index) {
    if (choose.shift.timeslots[$index].selected === choose.shift.bookmulti) {
      return;
    }

    choose.shift.timeslots[$index].selected = choose.shift.timeslots[$index].selected ? choose.shift.timeslots[$index].selected + 1 : 1;
    choose.selectedSlots.push($index);
  };

  choose.removeTimeslot = function ($index) {
    choose.shift.timeslots[$index].selected = choose.shift.timeslots[$index].selected - 1;
    choose.selectedSlots.splice(choose.selectedSlots.indexOf($index), 1);
  };

  choose.addToWaitlist = function ($index) {
    choose.waitlistModal(choose.shift.timeslots[$index]);
  };

  choose.cancel = function () {
    $location.path('/');
  };
}